<div class="form-group mb-0 d-flex align-items-center position-relative">
  <input
    class="input dynamic-input"
    nbInput
    type="text"
    fullWidth
    fieldSize="small"
    [ngModel]="inputValue"
    (ngModelChange)="onChange($event)"
    (blur)="updateSelection()"
    placeholder="{{ ('PROPERTIES.DROPDOWN_SEARCH_LABEL' | translate) + ' ' + inputLabel }}"/>
  <nb-icon icon="search-outline" size="small" class="search-select-icon"></nb-icon>
  <ul class="boat-list">
    @for (option of filteredOptions$ | async; track option) {
      <li>
        <a (click)="onSelectionChange(option)" tabindex="0">{{ option }}</a>
      </li>
    }
  </ul>
</div>